package org.multiplatform.kotfolio.pages.flutter

import androidx.compose.runtime.*
import com.varabyte.kobweb.compose.css.FontSize
import com.varabyte.kobweb.compose.css.FontWeight
import com.varabyte.kobweb.compose.css.TextAlign
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.ui.*
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.silk.components.text.SpanText
import org.jetbrains.compose.web.css.*
import org.jetbrains.compose.web.dom.Li
import org.jetbrains.compose.web.dom.Ul
import org.multiplatform.kotfolio.components.KotlinCode
import org.multiplatform.kotfolio.components.WebImage
import org.multiplatform.kotfolio.layout.BlogLayout
import org.multiplatform.kotfolio.layout.BlogProperties
import org.multiplatform.kotfolio.layout.PageProperties
import org.multiplatform.kotfolio.util.Resources

@Page("/flutter/firebase")
@Composable
fun FirebasePage() {
    BlogLayout(
        PageProperties(
            "Firebase",
            ""),
        BlogProperties("Flutter", "Notification | Cloud Firestore | CRUD Operation | Chat App")
    ) {
        Column(
            horizontalAlignment = Alignment.Start
        ) {
            SpanText(
                text = "Cloud Firestore setup (Flutter 3.19.5 and Android Studio Iguana | 2023.2.1 Patch 1)",
                modifier = Modifier.fontSize(FontSize.Large).padding(top = 1.em)
                    .fontWeight(FontWeight.Bold)
            )

            Ul {
                Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Flutter 3.19.5 version no need define build.gradle com.google.gms:google-services",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }
            }

            WebImage(src = Resources.Images.FIREBASE_SETUP_FLUTTER,
                modifier = Modifier.fillMaxWidth().padding(5.px).borderRadius(10.px),
                contentDescription = "Firebase setup")

            KotlinCode(
                code = """
                    void main() async {
                        WidgetsFlutterBinding.ensureInitialized();
                        await Firebase.initializeApp(options: FirebaseOptions(
                        apiKey: 'apiKey',
                        appId: 'appId',
                        messagingSenderId: 'messagingSenderId',
                        projectId: 'projectId',
                        storageBucket: 'storageBucket'));
                    }
                    """.trimIndent()
            )

            KotlinCode(
                code = """
                    //android/app/build.gradle
                    
                    plugins {
                        id "com.android.application"
                        id "kotlin-android"
                        id "dev.flutter.flutter-gradle-plugin"
                        id 'org.jetbrains.kotlin.android'
                        id "com.google.gms.google-services" version "4.4.1" apply false
                    }
                    """.trimIndent()
            )

            SpanText(
                text = "Flutter 3.19.5 android file structure",
                modifier = Modifier.fontSize(FontSize.Large).padding(top = 1.em)
                    .fontWeight(FontWeight.Bold)
            )

            WebImage(src = Resources.Images.FLUTTER_3_19_5,
                modifier = Modifier.fillMaxWidth().padding(5.px).borderRadius(10.px),
                contentDescription = "Flutter 3.19.5 version")

            SpanText(
                text = "Facebook Login",
                modifier = Modifier.fontSize(FontSize.Large).padding(top = 1.em)
                    .fontWeight(FontWeight.Bold)
            )

            KotlinCode(
                code = """
                    final LoginResult result = await FacebookAuth.instance.login(permissions: [
                    "email",
                    "public_profile",
                    "user_friends"
                    ]);

                    switch (result.status) {
                        case LoginStatus.success:

                        final AccessToken(:token) = result.accessToken!;

                        AuthCredential credential = FacebookAuthProvider.credential(token);
                        UserCredential userCredential = await FirebaseAuth.instance.signInWithCredential(credential);

                        final User(:uid, :displayName, :email, :emailVerified, :isAnonymous, :photoURL, :refreshToken) = userCredential.user!;
                        print(displayName);

                        break;

                        case LoginStatus.cancelled:

                        break;

                        case LoginStatus.failed:

                        break;

                        case LoginStatus.operationInProgress:
                        break;
                    }
                    
                    //manifest
                    <!-- FACEBOOK -->
                            <meta-data android:name="com.facebook.sdk.ApplicationId" android:value="@string/facebook_app_id" />
                            <meta-data android:name="com.facebook.sdk.ClientToken" android:value="@string/facebook_client_token"/>
                            <activity android:name="com.facebook.FacebookActivity" android:configChanges=
                                "keyboard|keyboardHidden|screenLayout|screenSize|orientation" android:label="@string/app_name" />

                            <activity android:name="com.facebook.CustomTabActivity" android:exported="true">
                                <intent-filter>
                                    <action android:name="android.intent.action.VIEW" />
                                    <category android:name="android.intent.category.DEFAULT" />
                                    <category android:name="android.intent.category.BROWSABLE" />
                                    <data android:scheme="@string/fb_login_protocol_scheme" />
                                </intent-filter>
                            </activity>
                    """.trimIndent()
            )

            SpanText(
                text = "SH1 generate mac",
                modifier = Modifier.fontSize(FontSize.Large).padding(top = 1.em)
                    .fontWeight(FontWeight.Bold)
            )

            Ul {
                Li {
                    SpanText(
                        text = "gradlew -> open in -> terminal open -> run command: ./gradlew signingReport",
                        modifier = Modifier.padding(bottom = 0.3.em)
                            .fontSize(FontSize.Medium)
                            .textAlign(TextAlign.Start)
                    )
                }
            }

            SpanText(
                text = "Google Login",
                modifier = Modifier.fontSize(FontSize.Large).padding(top = 1.em)
                    .fontWeight(FontWeight.Bold)
            )

            KotlinCode(
                code = """
                    final GoogleSignInAccount? googleSignInAccount = await GoogleSignIn().signIn();

                    if (googleSignInAccount != null) {
                        final GoogleSignInAuthentication? googleSignInAuthentication = await googleSignInAccount.authentication;
                        final AuthCredential credential = GoogleAuthProvider.credential(
                            accessToken: googleSignInAuthentication?.accessToken,
                        idToken: googleSignInAuthentication?.idToken);

                        try {
                            final UserCredential userCredential = await FirebaseAuth.instance.signInWithCredential(credential);
                            var token = await FirebaseAuth.instance.currentUser!.getIdToken();

                            final User(:uid, :displayName, :email, :emailVerified, :isAnonymous, :photoURL, :refreshToken) = userCredential.user!;

                        }
                        catch(ex) {

                        }
                    }
                    """.trimIndent()
            )

            SpanText(
                text = "Firestore withConverter",
                modifier = Modifier.fontSize(FontSize.Large).padding(top = 1.em)
                    .fontWeight(FontWeight.Bold)
            )

            KotlinCode(
                code = """
                    import 'package:cloud_firestore/cloud_firestore.dart';

                    class Booking {
                      final String id;
                      final String place;
                      final int price;
                      final DateTime createdAt;

                      Booking({required this.id, required this.place, required this.price, required this.createdAt});

                      factory Booking.fromFirestore(DocumentSnapshot<Map<String, dynamic>> snapshot,
                          SnapshotOptions? options) {
                        final data = snapshot.data();
                        return Booking(
                            place: data?['place'],
                            price: data?['price'],
                            createdAt: data?['createdAt'].toDate());
                      }

                      Map<String, dynamic> toFirestore() {
                        return {
                          "id": id,
                          "place": place,
                          "price": price,
                          "createdAt": createdAt,
                        };
                      }
                    }
                    """.trimIndent()
            )

            KotlinCode(
                code = """
                    import 'package:cloud_firestore/cloud_firestore.dart';

                    class FirestoreHelper {
                      Future<List<DocumentSnapshot>> selectAllBookings(String userId) async {
                        final collectionRef = FirebaseFirestore.instance
                            .collection("")
                            .doc(userId)
                            .collection(_subCollectionBookings)
                            .withConverter(
                              fromFirestore: Booking.fromFirestore,
                              toFirestore: (Booking bookings, _) => bookings.toFirestore(),
                            );
                        final collectionSnap = await collectionRef.get();
                        return collectionSnap.docs;
                      }

                      Future<Booking?> selectBooking(String userId, String place) async {
                        final docRef = FirebaseFirestore.instance
                            .collection("")
                            .doc(userId)
                            .collection(_subCollectionBookings)
                            .doc(place)
                            .withConverter(
                                fromFirestore: Booking.fromFirestore,
                                toFirestore: (Booking booking, _) => booking.toFirestore());
                        final docSnap = await docRef.get();
                        return docSnap.data();
                      }

                      Future<void> insert(Booking booking, String userId) async {
                        final docRef = FirebaseFirestore.instance
                            .collection("")
                            .doc(userId)
                            .collection(_subCollectionBookings)
                            .doc(booking.place)
                            .withConverter(
                                fromFirestore: Booking.fromFirestore,
                                toFirestore: (Booking booking, _) => booking.toFirestore());
                        return await docRef.set(booking);
                      }

                      Future<void> delete(String userId, String docId) async {
                        return await FirebaseFirestore.instance
                            .collection("")
                            .doc(userId)
                            .collection(_subCollectionBookings)
                            .doc(docId)
                            .delete();
                      }
                    }
                    """.trimIndent()
            )

            KotlinCode(
                code = """
                      List<Booking> _bookingList = [];
                      
                      List<Booking> _bookingListFromDocToList(
                          List<DocumentSnapshot> bookingSnapshot) {
                        return bookingSnapshot
                            .map((doc) => Booking(
                                place: doc['place'],
                                price: doc['price'],
                                createdAt: doc['createdAt'].toDate()))
                            .toList();
                      }
                      
                      void _getBookingList() async {
                          List<DocumentSnapshot> bookingSnapshot =
                          await FirestoreHelper.instance.selectAllBookings(_userId);
                          _bookingList = _bookingListFromDocToList(bookingSnapshot);
                      }

                      void _getBooking(String docId) async {
                            Booking? booking = await FirestoreHelper.instance.selectBooking(_userId, docId);
                      }
                    """.trimIndent()
            )
        }
    }
}

